import RecordersPage from "./RecordersPage";

export default RecordersPage;
